import React from 'react';
import { Link } from 'react-router-dom';
import { categories } from '../../data/products';
import './Categories.css';

const Categories = () => (
  <section className="categories" aria-labelledby="categories-heading">
    <div className="categories-wrap">
      <div className="categories-header">
        <h2 id="categories-heading">Shop by category</h2>
        <p className="categories-subtitle">Jump into the room you need — deals across every department.</p>
      </div>

      <div className="categories-circles">
        {categories.map((category) => (
          <Link key={category.id} to={`/category/${category.id}`} className="category-circle">
            <span className="category-circle-media">
              <img src={category.image} alt="" loading="lazy" />
            </span>
            <span className="category-circle-name">{category.name}</span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default Categories;
